import { Component } from "@angular/core";
import { IonicPage, NavParams } from "ionic-angular";
import { Api } from "../../services/api";
import { WeixinQr } from "../../services/weixin_qr";

@IonicPage({
  segment: "reseller-order-detail/:id",
})
@Component({
  selector: "page-reseller-order-detail",
  templateUrl: "reseller-order-detail.html",
})
export class ResellerOrderDetailPage {
  constructor(
    private navParams: NavParams,
    private api: Api,
    public weixinQr: WeixinQr
  ) {}

  intervalId = 0;
  data = { order: null };

  showWeixinQr() {
    if (this.data.order && this.data.order.qr_url) {
      this.weixinQr.show(
        this.data.order.qr_url_populated || this.data.order.qr_url,
        this.data.order.title
      );
    }
  }

  ionViewDidEnter() {
    this.refreshData();
    this.intervalId = setInterval(() => {
      this.refreshData();
    }, 5000);
  }

  ionViewWillUnload() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private refreshData() {
    this.api
      .resellerPaymentGetResellerOrderDetail(this.navParams.data.id)
      .then((resp) => {
        this.data.order = resp.order;
        if (localStorage["showQrForResellerOrder"] == this.navParams.data.id) {
          delete localStorage["showQrForResellerOrder"];
          this.showWeixinQr();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reseller-order-detail/reseller-order-detail.ts